/* app/ui/track/preload */

import $ from 'jquery';
import { Util } from 'App/track/analytics/util';

var preloadEvents = window._trackPreloadEvents;

var selectors = {

};

var Track = {
	init: function () {
		// console.log( 'Track Preload Init' );

		var preloadEvents = window._trackPreloadEvents;

		if ( typeof preloadEvents != 'undefined' && preloadEvents.length ) {
			for ( var i = 0; i < preloadEvents.length; i++ ) {
				var data = preloadEvents[i];

				Util.publishEvent( data );
			}
		}
	}
};

export { Track as Preload };
